module.exports = __webpack_public_path__ + "img/logo_w.86659333.png";